export default __webpack_public_path__ + "static/media/home_carousel_4.adc3adbb.jpg";